import { ProductsOrderBy, type ProductsOrderByT } from '@vs-shop/schemas/enum/productsOrderBy';
import { Match } from 'effect';

export const PRODUCTS_ENDPOINT = '/api/v2/shop/products';
export const PRODUCT_VARIANTS_ENDPOINT = '/api/v2/shop/product-variants';
export const HTTP_METHOD = 'get';
export const ASSOCIATION_TYPE = 'produktypodobne,nahradnidily';

const createdAtDescending = { 'order[createdAt]': 'desc' } satisfies {
  readonly 'order[createdAt]': 'desc';
};
const priceAscending = { 'order[price]': 'asc' } satisfies {
  readonly 'order[price]': 'asc';
};
const priceDescending = { 'order[price]': 'desc' } satisfies {
  readonly 'order[price]': 'desc';
};

export const getContextOrderParams = (orderBy: ProductsOrderByT) =>
  Match.value(orderBy).pipe(
    Match.when(ProductsOrderBy.BESTSELLERS, () => ({})),
    Match.when(ProductsOrderBy.RELEVANCE, () => ({})),
    Match.when(ProductsOrderBy.CREATED_AT_ASC, () => createdAtDescending),
    Match.when(ProductsOrderBy.PRICE_ASC, () => priceAscending),
    Match.when(ProductsOrderBy.PRICE_DESC, () => priceDescending),
    Match.exhaustive
  );

export const getSearchOrderParams = (orderBy: ProductsOrderByT) =>
  Match.value(orderBy).pipe(
    Match.when(ProductsOrderBy.RELEVANCE, () => ({})),
    Match.when(ProductsOrderBy.BESTSELLERS, () => ({})),
    Match.when(ProductsOrderBy.CREATED_AT_ASC, () => createdAtDescending),
    Match.when(ProductsOrderBy.PRICE_ASC, () => priceAscending),
    Match.when(ProductsOrderBy.PRICE_DESC, () => priceDescending),
    Match.exhaustive
  );

/** IRI filter value for taxon-scoped product queries — single source for the template. */
export const taxonExpandIri = (
  rawUrlEncode: (input: string) => string,
  taxonCode: string
): string => `/api/v2/shop/taxons/${rawUrlEncode(taxonCode)}/expand`;
